export default "__VITE_ASSET__5329c70d__"